import React from 'react';
import { graphql } from 'gatsby';
import {
    KontentStringValue,
    CTAConfiguration,
    KontentRadioMultiChoice,
    KontentMedia,
    KontentRichText,
    BrandColor,
} from '../../../types/KontentProps';
import ProductDescription from './ProductDescription';
import { getMultiChoice } from '../Global/DataUtils';

type CtaFunctions = 'page_link' | 'form' | 'no_cta';

export interface ProductDescriptionProps extends CTAConfiguration {
    hide_component?: KontentRadioMultiChoice<'yes' | 'no' | undefined>;
    cta_function?: KontentRadioMultiChoice<CtaFunctions>;
    description_image: KontentMedia;
    long_description: KontentRichText;
    short_description: KontentStringValue;
    sub_title: KontentStringValue;
    contact_form: KontentStringValue;
    product_display_name: KontentRichText;
    content_panel__content_panel_font_color: BrandColor;
    content_panel__content_panel_color: BrandColor;
    secondary_image: KontentMedia;
    kontentItemId?: string;
}

const ProductDescriptionContainer: React.FC<ProductDescriptionProps> = (
    props
) => {
    if (getMultiChoice(props.hide_component) === 'yes') {
        return null;
    }

    return <ProductDescription {...props} />;
};

export default ProductDescriptionContainer;

export const fragmentProductDescription = graphql`
    fragment ProductDescription on kontent_item_component___product_description {
        elements {
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_function {
                value {
                    codename
                }
            }
            product_display_name {
                value
            }
            description_image {
                ...kontentImage
            }
            secondary_image {
                ...kontentImage
            }
            long_description {
                ...kontentRichText
            }
            short_description {
                value
            }
            sub_title {
                value
            }
            contact_form {
                value
            }
            content_panel__content_panel_color {
                ...kontentColor
            }
            content_panel__content_panel_font_color {
                ...kontentColor
            }
            hide_component {
                value {
                    codename
                }
            }
        }
    }
`;
